import React from 'react';
const BrandingHeader = () => {
  return (
    <div className="text-center mb-8">
      <img
        src="/assets/images/logo-black-on-white.png"
        alt="Ougama"
        className="w-40 mx-auto mb-4"
      />
      <p className="text-muted-foreground text-base">
        Workforce Management System
      </p>
      
    </div>
  );
};

export default BrandingHeader;
